import "../../../App.css";
import React, { useCallback, useEffect, useState } from "react";
import { Descriptions, Form, Layout, message, Result, Typography } from "antd";
import "antd/dist/reset.css";
import useAxios from "axios-hooks";
import { CheckoutSubmissionRequest } from "../../../types/CheckoutSubmissionRequest";
import { useOrderId } from "../../../hooks/UseOrderId";
import { Copyable } from "../../common/Copyable";
import { PaymentType } from "../../../App";
import { CheckoutStatusResult } from "../../../types/CheckoutStatusResult";
import { ProviderTypeEnum } from "../../../types/ProviderTypeEnum";
import YoutubeEmbedVideo from "../../common/YoutubeEmbedVideo";
import WrappedCard from "../../antd/WrappedCard";

const { Content } = Layout;

const ignore = false;
const OverdueTime = 3 * 60 * 1000;
const PollingTime = 5 * 1000;

// NOTICE: GET目前是同步的，后面有可能会需要支援非同步，近来收银台后先转圈等到GET有结果
function PkKuickPayIdMode({ getCheckoutInfoData }: PaymentType) {
  const id = useOrderId();

  const [{ data: putData, loading: putLoading, error: putError }, executePost] =
    useAxios<CheckoutSubmissionRequest>(
      {
        url: `/v2/checkout/${id}`,
        method: "POST"
      },
      { manual: true }
    );
  console.log("[POST] checkout.putData", putData);

  const [
    {
      data: getCheckoutResultData,
      loading: pollingLoading,
      error: getCheckoutResultError
    },
    pollingCheckoutResult
  ] = useAxios<CheckoutStatusResult>(`/v2/orders/${id}`, {
    manual: true
  });

  // NOTICE: model
  // const [providerName, setProviderName] = useState<CardTypeEnum>(CardTypeEnum.EasyPaisa);
  const [submitCheckout, setSubmitCheckout] = useState(false);

  // NOTICE: ant design
  const [form] = Form.useForm();
  const [messageApi, contextHolder] = message.useMessage();

  const onFormValueChange = (changedValues: any, values: any) => {
    // console.log("onFormValueChange.changedValues", changedValues)
    // console.log("onFormValueChange.values", values)
    // setProviderType(values.providerType);
  };

  const onFormFinish = (values: any) => {
    console.log("onFinish.values", values);

    setSubmitCheckout(true);

    // NOTICE: 十秒輪詢
    // startPollingResult();

    // NOTICE: 三分截止
    startOverdueCountDown();

    if (!ignore) {
      executePost({
        data: {
          id: id,
          providerType: ProviderTypeEnum.WALLET,
          providerName: values.providerName,
          customerAccount: values.customerAccount,
          customerEmail: values.customerEmail,
          customerIdCard: values.customerIdCard
        }
      })
        .then(() => {
          // messageApi.success("Success");
          setSubmitCheckout(true);
        })
        .catch((error) => {
          messageApi.error("Failed:" + error?.response?.data?.title);
          // console.log("error", error?.response?.data?.title);
        })
        .finally(() => {});
    }
  };

  const onFormFinishFailed = (errorInfo: any) => {
    // console.log("onFinishFailed.errorInfo", errorInfo)
    // messageApi.error("Failed:" + errorInfo);
  };

  const onButtonClick = () => {
    form.submit();
  };

  const [isOverdueTime, setIsOverdueTime] = useState<boolean>(false);
  console.log("0.isOverdueTime", isOverdueTime);

  // NOTICE: deprecated 十秒輪詢 way2
  // let pollingCountDown: NodeJS.Timeout;
  // const startPollingResult = useCallback(() => {
  //     console.log("[Polling] start to polling");
  //     console.log("1.isOverdueTime", isOverdueTime);
  //     pollingCountDown = setTimeout(function(){
  //         pollingCheckoutResult().then((data)=> {
  //             console.log("[Polling] end to polling.data", data);
  //         }).catch((error) => {
  //             console.log("[Polling] restart to polling.error", error);
  //         }).finally(() => {
  //             // console.log("isOverdueTime", isOverdueTime);
  //             // if(!isOverdueTime) {
  //             //     startPollingResult();
  //             // } else {
  //             //     console.log("停止輪詢")
  //                 // clearPollingCountDown();
  //             // }
  //         });
  //     }, PollingTime);
  // }, []);

  // NOTICE: 十秒輪詢 way1
  useEffect(() => {
    let pollingCountDown: NodeJS.Timeout;
    if (isOverdueTime) {
      console.log(
        "[Polling] Cause overdue time , so no need to process to poll"
      );
    } else if (!submitCheckout) {
      console.log("[Polling] no need to process to poll");
    } else {
      console.log("[Polling] pollingLoading", pollingLoading);
      if (getCheckoutResultData?.status !== "SUCCESS") {
        console.log("[Polling] restart to polling");
        // startPollingResult();
        pollingCountDown = setTimeout(function () {
          pollingCheckoutResult()
            .then((data) => {
              console.log("[Polling] end to polling.data", data);
            })
            .catch((error) => {
              console.log("[Polling] restart to polling.error", error);
            })
            .finally(() => {});
        }, PollingTime);
      } else if (getCheckoutResultData?.status === "SUCCESS") {
        console.log("[Polling] end to polling.data", getCheckoutResultData);
      }
    }
    return () => {
      if (pollingCountDown) clearTimeout(pollingCountDown);
    };
  }, [submitCheckout, pollingLoading, isOverdueTime, getCheckoutResultData]);

  // NOTICE: 三分截止
  let countDown: NodeJS.Timeout;
  const startOverdueCountDown = useCallback(() => {
    console.log("[CountDown] start to count down");
    countDown = setTimeout(function () {
      console.log("[CountDown] end to count down");
      setIsOverdueTime(true);
    }, OverdueTime);
  }, []);

  const clearOverdueCountDown = () => {
    clearTimeout(countDown);
  };
  useEffect(() => {
    return () => {
      // clearPollingCountDown();
      clearOverdueCountDown();
    };
  });

  return (
    <>
      {contextHolder}

      {/*NOTICE: 訂單未完成*/}
      {getCheckoutInfoData?.checkoutStatus !== "SUBMITTED" &&
        !submitCheckout && (
          <Content>
            <WrappedCard cardTitle="Payment details">
              <Descriptions bordered>
                <Descriptions.Item label="Amount">
                  <Typography.Title
                    copyable={{ icon: <Copyable /> }}
                    level={5}
                    style={{ margin: 0 }}
                  >
                    {getCheckoutInfoData?.orderAmount}
                  </Typography.Title>
                </Descriptions.Item>
                <Descriptions.Item label="KuickPay ID">
                  <Typography.Title
                    copyable={{ icon: <Copyable /> }}
                    level={5}
                    style={{ margin: 0 }}
                  >
                    {getCheckoutInfoData?.receiverAccount}
                  </Typography.Title>
                </Descriptions.Item>
              </Descriptions>
            </WrappedCard>

            <WrappedCard cardTitle="Don't know how to do?">
              <Descriptions>
                <Descriptions.Item>
                  Open your Easypaisa or Jazzcash, search KuickPay, then paste
                  the ID to make a payment. Or follow the video below.
                </Descriptions.Item>
              </Descriptions>
              <YoutubeEmbedVideo
                src={"https://www.youtube-nocookie.com/embed/OXgPj_E07J0"}
              ></YoutubeEmbedVideo>
            </WrappedCard>
          </Content>
        )}

      {/*NOTICE: 使用者填寫完畢送出，會看到等待付款中狀態頁面。*/}
      {submitCheckout &&
        !isOverdueTime &&
        getCheckoutResultData?.status !== "SUCCESS" && (
          <Result
            status="info"
            title="Please navigate to the wallet application and approve the transaction."
          />
        )}

      {/*NOTICE: 系統超過三分鐘後，使用者會看到訂單有問題之類訊息(後端之後會動態調整文案)。*/}
      {submitCheckout &&
        isOverdueTime &&
        getCheckoutResultData?.status !== "SUCCESS" && (
          <Result
            status="warning"
            title="We have not received your payment yet. If the transaction is delayed, please reach out to customer service if there is no further progress within two hours."
          />
        )}

      {/*NOTICE: 訂單已完成*/}
      {(getCheckoutResultData?.status === "SUCCESS" ||
        getCheckoutInfoData?.checkoutStatus === "SUBMITTED") && (
        <Result status="success" title="Successfully Paid" />
      )}
    </>
  );
}

export default PkKuickPayIdMode;
